module.exports = __webpack_public_path__ + "img/18.49c9e864.png";